import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { erpApi } from '@/shared/axios/erp-api';
import { urlBackend } from '@/shared/constants';
import {Costos , CostosPagingRes} from '@/shared/interfaces/erp/activos/costo-activo.interface';
import { useUiStore } from '@/store/ui';
import { getUrlParamsFetch, handleAxiosError } from '@/shared';
import { AlertSeverityEnum, UseMutationsParams } from '@/shared/interfaces';


const { get, post, put,remove } = erpApi();

///* tanSctack query
export const usefetchCostos = (params?: GetCostosParams) => {
    return useQuery({
      queryKey: ['Costos', ...Object.values(params || {})],
      queryFn: async () => {
        return getCostos(params);
      },
    });
  };
  
  export const useGetCosto = (id: string) => {
    return useQuery({
      queryKey: ['Costos', id],
      queryFn: async () => {
        return getCosto(id);
      },
    });
  };
  export const useCreateCostos = ({
    navigate,
  
    enableRedirect = true,
    returnUrl,
  
    returnErrorUrl,
    enableErrorRedirect = false,
    customMessageErrorAlert,
  
    enableSuccessAlert = true,
    customSuccessMessage,
  }: UseMutationsParams) => {
    const queryClient = useQueryClient();
    const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
    const setAlert = useUiStore.getState().setAlert;
  
    return useMutation({
      mutationFn: createCostos,
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['Costos'] });
  
        enableRedirect && navigate && returnUrl && navigate(returnUrl);
  
        enableSuccessAlert &&
          setAlert &&
          setAlert(
            true,
            customSuccessMessage ?? 'Costo creado correctamente',
            AlertSeverityEnum.success
          );
      },
      onError: error => {
        enableErrorRedirect &&
          navigate &&
          returnUrl &&
          navigate(returnErrorUrl ?? (returnUrl || ''));
  
        handleAxiosError(error, customMessageErrorAlert);
      },
      onSettled: () => {
        setIsGlobalLoading(false);
      },
    });
  };
  
  export const useUpdateCostos = ({
    navigate,
  
    enableRedirect = true,
    returnUrl,
  
    returnErrorUrl,
    enableErrorRedirect = false,
    customMessageErrorAlert,
  
    enableSuccessAlert = true,
    customSuccessMessage,
  }: UseMutationsParams) => {
    const queryClient = useQueryClient();
    const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
    const setAlert = useUiStore.getState().setAlert;
  
    return useMutation({
      mutationFn: updateCostos,
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['Costos'] });
        enableRedirect && navigate && returnUrl && navigate(returnUrl);
  
        enableSuccessAlert &&
          setAlert &&
          setAlert(
            true,
            customSuccessMessage ?? 'Costo actualizado correctamente',
            AlertSeverityEnum.success
          );
      },
      onError: error => {
        enableErrorRedirect &&
          navigate &&
          returnUrl &&
          navigate(returnErrorUrl ?? (returnUrl || ''));
  
        handleAxiosError(error, customMessageErrorAlert);
      },
      onSettled: () => {
        setIsGlobalLoading(false);
      },
    });
  };

  export const useDeleteCostos = () => {
    const queryClient = useQueryClient();
    const setConfirmDialogIsOpen = useUiStore.getState().setConfirmDialogIsOpen;
  
    return useMutation({
      mutationFn: async (id: string) => removeCostos(id),
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['Costos'] });
        setConfirmDialogIsOpen(false);
      },
      onError: (error) => {
        handleAxiosError(error);
      },
    });
  };
  
  ///* axios
  export type GetCostosParams = {
    page?: number,
    page_size?:number,
    id_costo?:string,
    codigo?:string,
    numero_referencia?:string,

  };
  
  export type CreateCostosParams = Omit<Costos, 'id_costo'>;
  export type UpdateCostosParams = {
    id: string;
    data: Omit<Costos, 'id_costo'>;
  };
  
  export const getCostos = async (params?: GetCostosParams) => {
    const queryParams = getUrlParamsFetch({ ...params });
  
    return get<CostosPagingRes>(
      `${urlBackend}api/v1/costo/?${queryParams}`,
      true
    );
  };
  
  export const getCosto = async (id: string) => {
 try{
 return await get<Costos>(`${urlBackend}api/v1/costo/${id}/`, true);
 }
 catch(error){
   return handleAxiosError(error);
 }
  };
  
  export const createCostos = async (data: CreateCostosParams) => {
    const setAlert = useUiStore.getState().setAlert;
    const res = await post<Costos>(`${urlBackend}api/v1/costo/`, data, true);
    setAlert(true, res.message, res.status);
    return res;
  };
  
  export const updateCostos = async ({ id, data }: UpdateCostosParams) => {
    const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
    setIsGlobalLoading(true);
    return put<Costos>(`${urlBackend}api/v1/costo/${id}/`, data, true);
  };
  
  
  export const removeCostos = async (id: string) => {
    const setAlert = useUiStore.getState().setAlert;
      const res = await remove<Costos>(`${urlBackend}api/v1/costo/${id}/`, true);
      setAlert(true, res.message, res.status);
      return res;
  };
  